import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class SearchDisplayCheck {

  private visibilitySource = new BehaviorSubject(false);
  currentMessage = this.visibilitySource.asObservable();

  /* private searchresults = new BehaviorSubject({'searchres':false});
  searchResultsMessage = this.searchresults.asObservable(); */

  private searchresults = new Subject();
  searchResultsMessage = this.searchresults.asObservable();

  private poptabs = new BehaviorSubject(false);
  poptabsmessage = this.poptabs.asObservable();

  /* private tabSource = new BehaviorSubject({'tabenable':false,'ScreenTitle':''});
  tabmesage = this.tabSource.asObservable(); */

  private tabSource = new Subject();
  tabmesage = this.tabSource.asObservable();

  private searchresultsforvacations = new BehaviorSubject({ 'tabenable': false, 'ScreenTitle': '' });
  searchResultsVacationMessage = this.searchresultsforvacations.asObservable();


  changeVisibility(message: boolean) {
    this.visibilitySource.next(message);
  }

  changeSearchResVisibility(message: any) {
    this.searchresults.next(message);
  }

  changeSearchResForVacVisibility(message: any) {
    this.searchresultsforvacations.next(message);
  }

  addTab(message: any) {
    this.tabSource.next(message);
  }

  popTab(message) {
    this.poptabs.next(message);
  }

  unSubscribeaddTab() {
    this.tabSource.unsubscribe();
  }

  ngOnDestroy() {
    console.log('Service Destroyed');
  }

}
